import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {FACTION_CONFIGS_IMPLEMENTED} from '../../configs/factions';
import {setAvailableFactions, updatePlayerRewards} from '../../redux/actions';
import {API_BASE} from '../../utils/apiConfig';

/**
 * Покупка фракции за кристаллы — общая логика для магазина (ShopPage) и
 * карусели выбора фракции (FactionSelectPage, локальная игра/сетевой матч):
 * оба места должны вести себя идентично (цена, проверка баланса, модалка
 * успешной покупки).
 */
export function useFactionPurchase(auth, availableFactions) {
  const dispatch = useDispatch();
  const [buyingFactionId, setBuyingFactionId] = useState(null);
  const [purchasedFactionId, setPurchasedFactionId] = useState(null);
  const [notEnoughCrystalsAmount, setNotEnoughCrystalsAmount] = useState(null);

  const handleBuyFaction = async (factionId) => {
    if (buyingFactionId) return;

    const faction = FACTION_CONFIGS_IMPLEMENTED.find((f) => f.id === factionId);
    if (!faction) return;

    if (auth.crystals < faction.priceCrystals) {
      setNotEnoughCrystalsAmount(faction.priceCrystals - (auth.crystals || 0));
      return;
    }

    setBuyingFactionId(factionId);
    try {
      const response = await fetch(`${API_BASE}/buy-faction`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({factionId}),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to buy faction');
      }

      dispatch(updatePlayerRewards(0, undefined, false, -faction.priceCrystals));
      dispatch(setAvailableFactions([
        ...availableFactions,
        {id: faction.id, name: faction.name, isAvailable: true},
      ]));
      setPurchasedFactionId(factionId);
    } catch (e) {
      console.error('Buy faction error', e);
      alert(e.message || 'Не удалось купить фракцию');
    } finally {
      setBuyingFactionId(null);
    }
  };

  return {
    buyingFactionId,
    handleBuyFaction,
    purchasedFactionId,
    setPurchasedFactionId,
    notEnoughCrystalsAmount,
    setNotEnoughCrystalsAmount,
  };
}
